<template>
    <v-simple-table>
        <tbody>
            <tr>
                <th> Contact Name</th>
                <td>{{ value.name }}</td>
            </tr>
            <tr>
                <th>Supplier</th>
                <td>
                <b>
                    {{ value.supplier ? value.supplier.name : null}}
                    <v-btn icon @click="supplierNavigate" v-if="hasPermission(perm.supplier.read)">
                        <v-icon>mdi-menu-right</v-icon>
                    </v-btn>
                </b>
                </td>
            </tr>
            <tr>
                <th>Phone</th>
                <td>{{ value.phone }}</td>
            </tr>
            <tr>
                <th>Email</th>
                <td>{{ value.email }}</td>
            </tr>
            <tr>
                <th>Position</th>
                <td>{{ value.position }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex';
import permissions from './../../data/permissions';
export default {
    name: "SupplierContact",
    props: {
        value: Object,
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        supplierNavigate(){
           this.$router.push({ name: "SupplierDisplay", params: { id: this.value.supplier.id} }) 
        }
    }
}
</script>

<style>

</style>